import * as echarts from 'echarts';

export default {
  name: 'Aecharts',
  props: {
    id: { type: String, default: () => (`a-echarts-${Math.random().toString().substring(2)}`) },
    resizeCondition: { type: Array | String, default: () => ['width', 'transform'] },
    theme: { type: String, default: () => 'macarons' },
    option: { type: Object, default: () => ({}) },
    grid: { type: Array, default: () => ['0', '0', '0', '0'] },
    color: { type: String, default: () => '#aaa' },
    fontSize: { type: String | Number, default: () => '12' },
    textStyle: { type: Object, default: () => ({}) },
    background: { type: String, default: () => '' },
    animationDuration: { type: String | Number, default: () => 0 },
    delay: { type: String | Number, default: () => 600 },
  },
  data() {
    return {
      charts: null,
      timeout: null,
      styles: {
        textStyle: {
          color: this.color,
          fontSize: parseInt(this.fontSize),
          ...this.textStyle,
        },
      },
    }
  },
  watch: {
    option: {
      deep: true,
      handler() {
        this.create();
      }
    },
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    create() {
      let theme = require(`echarts/theme/${this.theme}`);
      this.$nextTick(() => {
        if (!theme) console.error(`echarts themes for ${this.theme} load failed.`);
        this.charts = echarts.init(this.$el, this.theme, { autoSize: true });
        this.$nextTick(() => {
          if (this.charts) {
            this.charts.clear();
            this.$nextTick(() => {
              let option = ({
                backgroundColor: this.background,
                animationEasing: 'cubicInOut',
                animationDuration: this.animationDuration || this.delay,
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'cross',
                    label: {},
                  }
                },
                grid: {
                  show: false,
                  top: parseInt(this.grid[0] || Math.ceil(this.fontSize / 2) || 0),
                  right: parseInt(this.grid[1] || this.grid[0] || 0),
                  bottom: parseInt(this.grid[2] || this.grid[0] || 0),
                  left: parseInt(this.grid[3] || this.grid[1] || this.grid[0] || 0),
                  containLabel: true,
                  ...this.styles,
                },
                yAxis: {
                  show: false,
                  splitLine: { show: false },
                  axisLabel: {
                    ...this.styles,
                  },
                },
                xAxis: {
                  show: false,
                  splitLine: { show: false },
                  axisLabel: {
                    ...this.styles,
                  },
                },
                ...this.option,
              });
              this.$nextTick(() => {
                this.charts.off('click');
                this.$nextTick(() => {
                  this.charts.on('click', a => {
                    this.$emit('click', a);
                    this.$emit('select', a);
                    this.$emit('choose', a);
                  });
                  this.$nextTick(() => {
                    this.charts.setOption(option, true);
                    this.$nextTick(() => {
                      this.charts.resize();
                      this.$nextTick(() => {
                        if (this.timeout) {
                          clearTimeout(this.timeout);
                          this.timeout = null;
                        } else {
                          this.timeout = setTimeout(() => {
                            addEventListener('resize', this.resize);
                            clearTimeout(this.timeout);
                            this.timeout = null;
                          }, 200);
                        }
                      });
                    });
                  });
                });
              });
            });
          }
        });
      });
    },
    resize() {
      this.charts && (this.charts.resize());
    },
    cancel() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      if (this.charts) {
        removeEventListener('resize', this.resize);
        this.$nextTick(() => {
          this.charts.clear();
          this.$nextTick(() => {
            let charts = echarts.getInstanceByDom(this.$el);
            this.$nextTick(() => {
              charts && (this.charts.dispose(charts));
              this.$nextTick(() => {
                charts = null;
                this.$nextTick(() => {
                  this.charts.dispose();
                  this.$nextTick(() => this.charts = null);
                });
              });
            });
          });
        });
      }
    },
  },
  render() {
    const { width = '100%', height = '100%' } = this.$attrs;
    return (<div id={this.id} class="a-echarts" style={{ width, height }} />);
  },
}